import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SITE } from "@/lib/site";
import { useSectionNav } from "@/lib/scroll";

const links = [
  { label: "Home", id: "home" }, { label: "Services", id: "services" }, { label: "Website Care", id: "website-care" },
  { label: "Portfolio", id: "portfolio" }, { label: "About", id: "about" }, { label: "Get a Quote", id: "quote" }, { label: "Contact", id: "contact" },
];

export const Footer = () => {
  const goTo = useSectionNav();
  return (
    <footer className="border-t border-white/[0.06] bg-ink2/70" data-testid="footer">
      <div className="container-x grid gap-12 py-16 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-slate-400 max-w-sm leading-relaxed">{SITE.tagline}. Modern, responsive websites designed around your business — we launch your new website and take care of it as well.</p>
        </div>
        <nav aria-label="Footer navigation">
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Navigate</h3>
          <ul className="mt-5 space-y-2.5">
            {links.map((l) => (
              <li key={l.id}><button onClick={() => goTo(l.id)} className="text-sm text-slate-300 hover:text-white transition-colors" data-testid={`footer-link-${l.id}`}>{l.label}</button></li>
            ))}
          </ul>
        </nav>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Contact</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-slate-300">
            <li><span className="text-slate-500">Phone: </span><a href={SITE.phoneHref} className="hover:text-white" data-testid="footer-phone">{SITE.phone}</a></li>
            <li><span className="text-slate-500">Email: </span><a href={SITE.emailHref} className="hover:text-white break-all" data-testid="footer-email">{SITE.email}</a></li>
            <li><span className="text-slate-500">ABN: </span><span className="font-mono" data-testid="footer-abn">{SITE.abn}</span></li>
          </ul>
        </div>
        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Legal</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-slate-300">
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.06]">
        <div className="container-x flex flex-col sm:flex-row justify-between gap-2 py-6 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {SITE.name}. ABN {SITE.abn}.</p>
          <p>{SITE.tagline}</p>
        </div>
      </div>
    </footer>
  );
};
